import { Link } from 'react-router-dom';

const steps = [
  {
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 384 512">
        <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" />
      </svg>
    ),
    title: 'Choose Your City',
    description: 'Tell us where you want to host.',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 448 512">
        <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" />
      </svg>
    ),
    title: 'Pick Your Cast Member',
    description: 'Select the show or star for your class.',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 448 512">
        <path d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z" />
      </svg>
    ),
    title: 'Pick Your Time',
    description: 'Choose a date and time that works best.',
  },
];

export default function ConnectionSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container-wide">
        {/* Centered heading */}
        <h2 className="text-center mb-12 text-warm-900 font-bold">
          Create CONNECTIONS with Professional Dancers that are Inspiring, Fun
          and Educational!
        </h2>

        {/* Two-column: image left, steps right */}
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left: Featured dancer image */}
          <div className="relative">
            <img
              src="/images/connection/featured-dancer.jpg"
              alt="Dance instructor teaching a masterclass"
              className="rounded-lg shadow-xl w-full"
            />
          </div>

          {/* Right: Three steps stacked vertically */}
          <div>
            <h2 className="mb-8 text-warm-900">
              Select your class options in three easy steps!
            </h2>

            <div className="space-y-8">
              {steps.map((step, i) => (
                <div
                  key={step.title}
                  className="animate-fade-in-up"
                  style={{ animationDelay: `${(i + 1) * 0.2}s` }}
                >
                  <div className="bg-accent-100 text-accent-600 rounded-full w-14 h-14 flex items-center justify-center mb-3">
                    {step.icon}
                  </div>
                  <h3 className="mb-1 text-warm-900 font-bold">{step.title}</h3>
                  <p className="text-warm-500">{step.description}</p>
                </div>
              ))}
            </div>

            <Link
              to="/events"
              className="btn mt-8 inline-block bg-warm-800 text-white hover:bg-warm-900 !py-2.5 !px-6 rounded-lg"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
